"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var model_1 = require("../diagram/model");
var schema_1 = require("../data/schema");
var events_1 = require("../viewUtils/events");
var async_1 = require("../viewUtils/async");
var spinner_1 = require("../viewUtils/spinner");
var SelectLinkType = /** @class */ (function (_super) {
    tslib_1.__extends(SelectLinkType, _super);
    function SelectLinkType(props) {
        var _this = _super.call(this, props) || this;
        _this.listener = new events_1.EventObserver();
        _this.cancellation = new async_1.Cancellation();
        _this.updateAll = function () { return _this.forceUpdate(); };
        _this.onChangeType = function (e) {
            var linkTypeId = e.currentTarget.value;
            _this.props.onChange(tslib_1.__assign({}, _this.props.link, { linkTypeId: linkTypeId }));
        };
        _this.state = {};
        return _this;
    }
    SelectLinkType.prototype.componentDidMount = function () {
        this.fetchPossibleLinkTypes();
    };
    SelectLinkType.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.source !== this.props.source || prevProps.target !== this.props.target) {
            this.setState({ fatLinkTypes: undefined });
            this.fetchPossibleLinkTypes();
        }
    };
    SelectLinkType.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.cancellation.abort();
    };
    SelectLinkType.prototype.fetchPossibleLinkTypes = function () {
        var _this = this;
        var _a = this.props, view = _a.view, metadataApi = _a.metadataApi, source = _a.source, target = _a.target;
        if (!metadataApi) {
            return;
        }
        metadataApi.possibleLinkTypes(source, target, this.cancellation.signal).then(function (linkTypes) {
            var fatLinkTypes = {};
            linkTypes.forEach(function (linkTypeIri) { return fatLinkTypes[linkTypeIri] = view.model.createLinkType(linkTypeIri); });
            _this.setState({ fatLinkTypes: fatLinkTypes });
            _this.listenToLinkLabels(fatLinkTypes);
        });
    };
    SelectLinkType.prototype.listenToLinkLabels = function (fatLinkTypes) {
        var _this = this;
        Object.keys(fatLinkTypes).forEach(function (linkType) {
            return _this.listener.listen(fatLinkTypes[linkType].events, 'changeLabel', _this.updateAll);
        });
    };
    SelectLinkType.prototype.renderPossibleLinkType = function (fatLinkType) {
        var view = this.props.view;
        var label = model_1.formatLocalizedLabel(fatLinkType.id, fatLinkType.label, view.getLanguage());
        return React.createElement("option", { key: fatLinkType.id, value: fatLinkType.id }, label);
    };
    SelectLinkType.prototype.render = function () {
        var _this = this;
        var _a = this.props, link = _a.link, disabled = _a.disabled;
        var fatLinkTypes = this.state.fatLinkTypes;
        return (React.createElement("label", null,
            "Type",
            fatLinkTypes ? (React.createElement("select", { className: 'ontodia-form-control', value: link.linkTypeId, onChange: this.onChangeType, disabled: disabled },
                React.createElement("option", { value: schema_1.PLACEHOLDER_LINK_TYPE, disabled: true }, "Select link type"),
                Object.keys(fatLinkTypes).map(function (linkType) {
                    return _this.renderPossibleLinkType(fatLinkTypes[linkType]);
                }))) : React.createElement("div", null,
                React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 }))));
    };
    return SelectLinkType;
}(React.Component));
exports.SelectLinkType = SelectLinkType;
